import './styling.scss';
import * as angular from 'angular';
import * as template from './template.html';
import { PropertyDataDisplay } from 'utilities/propertyDataDisplay';
import { getFullAddress } from 'common/source/utilities/policyInfoDisplay';
import * as componentsModule from './components';
import { getFormattedAdditionalInformation } from './components/overview-additional-information-section';
import { CurrentUserService } from 'services/currentUser';
import { shouldShowCta } from 'utilities/paymentsHelper';
import { ModalService } from 'common/source/services/modal';
import { FlagshipService } from 'services/flagship';
import { checkFeatureFlagAndRedirect } from 'utilities/featureFlags';

const module = angular.module('overview-page', [componentsModule.module.name]);

interface OverviewPageController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;
    policyIndex: RoutePolicyIndex;
    smartHomeDiscount: number;

    fullAddress: string;

    propertyDataDisplay: PropertyDataDisplay;
    hasAdditionalInformation: boolean;
}

module.component('overviewPage', {
    template: template,
    bindings: {
        policyIndex: '<',
        policyInfo: '<',
        smartHomeDiscount: '<',
        proMonitoringStates: '<'
    },
    controller: function controller(
        this: OverviewPageController,
        currentUserService: CurrentUserService,
        modalService: ModalService,
        flagshipService: FlagshipService,
        $stateParams: PolicyStateParams,
        $window: angular.IWindowService,
        $scope: angular.IScope
    ) {
        'ngInject';

        const checkFeatureFlag = () => {
            checkFeatureFlagAndRedirect('ReactOverviewPage', flagshipService, $window, currentUserService, $stateParams.policyIndex);
        };

        this.$onInit = () => {
            if (flagshipService.getFeatureFlagStatus() === 'FeatureFlagStatus:Ready') {
                checkFeatureFlag();
            } else {
                $scope.$on('FeatureFlagStatus:Ready', () => {
                    checkFeatureFlag();
                });
            }

            this.hasAdditionalInformation = getFormattedAdditionalInformation(this.policyInfo).length > 0;
            this.propertyDataDisplay = new PropertyDataDisplay(this.policyInfo.property_data);
            this.fullAddress = getFullAddress(this.policyInfo);
            currentUserService.getPolicyCount().then((numOfPolicies) => {
                if (shouldShowCta(this.policyInfo, 'modal') && numOfPolicies === 1) {
                    modalService.openCloseableModal('login-cta', { policyInfo: this.policyInfo });
                }
            });
        };
    }
});

export { module };
